import React, { createContext, ReactNode } from 'react'

type CollectionStyleContextProps = {
    itemWidth: number | undefined
    showSearch: boolean
    selectedChannelIds: number[] | undefined
    showGifsBelow: boolean
}

type CollectionStyleContextManagerProps = {
    children: ReactNode
}

export const CollectionStyleContext = createContext({} as CollectionStyleContextProps)

const CollectionStyleContextManager = ({
    itemWidth,
    showSearch,
    selectedChannelIds,
    showGifsBelow,
    children,
}: CollectionStyleContextProps & CollectionStyleContextManagerProps) => {
    return (
        <CollectionStyleContext.Provider
            value={{
                itemWidth,
                showSearch,
                selectedChannelIds,
                showGifsBelow,
            }}
        >
            {children}
        </CollectionStyleContext.Provider>
    )
}

export default CollectionStyleContextManager
